import { useState } from 'react';
import { type NoticeResponseDto } from '@/api';
import { NoticeLogger } from '@/module/Notice/NoticeLogger';
import { AlertBanner } from '@/shared/components';
import { NoticeManager } from './NoticeStorage';
export const TextNotice = (props: NoticeResponseDto) => {
  const [isActive, setActive] = useState(true);
  const {
    id,
    content
  } = props;
  const handleClose = () => {
    NoticeManager.setNotice(id || '', 'TEXT');
    NoticeLogger.onClickClose(props);
    setActive(false);
  };
  if (!isActive) return null;
  return <AlertBanner title={content?.title || ''} onClose={handleClose} datatype="notice" data-sentry-element="AlertBanner" data-sentry-component="TextNotice" data-sentry-source-file="TextNotice.tsx" />;
};